<template>
  <div>
    <Func4PrintHeader />
    <div>
      <div class="prestador-header text-3xl border-b-2 p-2 font-bold">
        {{ prestador.razao_social }}
      </div>
      <div class="flex space-x-10">
        <div class="p-2">
          <div class="flex space-x-2 border-b">
            <div class="border-r flex-grow">
              <div class="font-bold">
                {{ prestador.razao_social }}
              </div>
              <div>
                {{ prestador.especialidade }}
              </div>
            </div>
            <div class="flex place-items-center space-x-2">
              <div class="icon w-6 h-6 rounded-full bg-fuchsia-300">
                <i class="el-icon-phone" />
              </div>
              <div class="font-bold">
                <div class="whitespace-nowwrap">
                  {{ prestador.telefone_primario }}
                </div>
                <div class="whitespace-nowwrap">
                  {{ prestador.telefone_secundario }}
                </div>
              </div>
            </div>
          </div>
          <div class="border-b">
            <div class="font-bold">
              <span>
                {{ prestador.endereco }}
              </span>
              <span>
                {{ prestador.numero }}
              </span>
              <span>
                {{ prestador.complemento }}
              </span>
            </div>
            <div>
              <span>Bairro:</span>
              <span class="font-bold">
                {{ prestador.bairro }}
              </span>
            </div>
            <div>
              <span>Cidade/UF:</span>
              <span class="font-bold">
                {{ prestador.cid }}
              </span>
              <span>CEP:</span>
              <span class="font-bold">
                {{ prestador.cep }}
              </span>
            </div>
          </div>
          <div class="text-2xl">Informações Gerais:</div>
          <div class="border-b">
            <span>Nome fantasia:</span>
            <span class="font-bold">
              {{ prestador.nome_prestador }}
            </span>
          </div>
          <div class="border-b">
            <span>CNPJ ou CPF:</span>
            <span class="font-bold">
              {{ prestador.cpf_cnpj }}
            </span>
          </div>
          <div class="border-b">
            <span>Conselho Regional:</span>
            <span class="font-bold">
              {{ prestador.sigla_conselho_regional }}
            </span>
          </div>
          <div class="border-b">
            <span>Acessibilidade:</span>
            <span class="font-bold">
              {{ prestador.acessibilidade === 'S' ? prestador.detalhe_acessibilidade : 'Não' }}
            </span>
          </div>
          <div class="border-b">
            <span>Atendimento 24h:</span>
            <span class="font-bold">
              {{ prestador.atend_24_horas === 'S' ? 'Sim' : 'Não' }}
            </span>
          </div>
          <div class="border-b">
            <span>Observações:</span>
            <span class="font-bold">
              {{ !prestador.observacoes || prestador.observacoes === ' ' ? 'Não informado' : prestador.observacoes }}
            </span>
          </div>
        </div>
        <div class="right">
          <div>
            <div class="font-bold border-b">Planos de Saúde</div>
            <div class="text-sm">
              <template v-for="(plano, index) in planos">
                <div :key="index">
                  <span class="font-bold">{{ plano.descricao }}</span>
                  <span> (Nº ANS: {{ plano.registro_plano_ANS }}, </span>
                  <span>{{ plano.classificacao_fins_comercializacao }}, </span>
                  <span>{{ plano.ativo ? 'Ativo' : 'Desativado' }})</span>
                </div>
              </template>
            </div>
          </div>
          <div>
            <div class="font-bold border-b">Outras Especialidades</div>
            <div class="text-sm">
              <template v-for="(especialidade, index) in especialidades">
                <span class="p-2" :key="index">
                  {{ especialidade.descricao }}
                </span>
              </template>
            </div>
          </div>
          <div>
            <div class="font-bold border-b">Horários</div>
            <div class="text-sm">
              <template v-for="(horario, index) in horarios">
                <div :key="index">
                  <span class="font-bold">{{ horario.titulo_horario }}</span>
                  <span>{{ ` (de ${horario.horario_inicial} até ${horario.horario_final})` }}</span>
                </div>
              </template>
            </div>
          </div>
          <div>
            <div class="font-bold border-b">Equipe médica</div>
            <div class="text-sm">
              <template v-for="(equipe, index) in equipeMedica">
                <div :key="index">
                  <span class="font-bold">{{ equipe.nome_corpo_clinico }}</span>
                  <span>{{
                      ` (${equipe.sigla_conselho_regional}: ${equipe.numero_conselho_regional} - ${equipe.descricao})`
                    }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Func4PrintHeader from '@/views/4/print/PrintHeader'
import { mapState } from 'vuex'

export default {
  name: 'Func4PrintPrestador',
  components: { Func4PrintHeader },
  computed: {
    ...mapState('RedeCredenciada', ['prestador', 'especialidades', 'planos', 'horarios', 'equipeMedica'])
  },
  mounted () {
    document.title = 'Impressão de prestador'
  }
}
</script>

<style scoped lang="less">
*,
::before,
::after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: currentColor;
}

.prestador-header {
  background: lightgrey;
  border-bottom: 2px solid dimgrey;
}

.flex {
  display: flex
}

.h-6 {
  height: 1.5rem
}

.w-6 {
  width: 1.5rem
}

.flex-grow {
  flex-grow: 1
}

.place-items-center {
  place-items: center
}

.space-x-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2.5rem * var(--tw-space-x-reverse));
  margin-left: calc(2.5rem * calc(1 - var(--tw-space-x-reverse)))
}

.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))
}

.rounded-full {
  border-radius: 9999px
}

.border-b-2 {
  border-bottom-width: 2px
}

.border-b {
  border-bottom-width: 1px
}

.border-r {
  border-right-width: 1px
}

.p-2 {
  padding: 0.5rem
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem
}

.text-sm {
  font-size: 1rem;
}

.font-bold {
  font-weight: 700
}

.whitespace-nowrap {
  white-space: nowrap;
}

</style>
